import { WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useThemeStatusStore } from 'store/themeStatus.store';

import { QueryResponse } from 'api/queries/getCriticalityWeightScurveGraph.query';

import { ProgressMeasurement } from 'components/common/GlobalFiltersInPage/components/progressMeasurementFilter/progressMeasurementFilter';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { getPoints, serializeData, serializeOptions } from 'components/widgets/SCurve/Scurve.utils';

const FILTER_LIST: ProgressMeasurement[] = [
    'activityCompleted',
    'activityCompletedCriticality',
    'activitySubmittedCompletion',
    'activitySubmittedCompletionCriticality',
];

const CHART_HEIGHT_IN_REPORT_VIEW = '100%';
const CHART_HEIGHT_IN_PAGE_VIEW = 600;

const filterDataBySelection = (data: QueryResponse, selectedOptions: string[]) => {
    if (data == null) return data;
    const dataFilterBySelection = Object.fromEntries(
        Object.entries(data).filter(([key]) => selectedOptions.includes(key)),
    );
    return dataFilterBySelection;
};

export const useScurveLogic = ({ ui, api, widgetViewMode, setIsPayloadReady }) => {
    const isPayloadReady = () => {
        const currentPayload = api.scurveGraph.payload;
        if (!currentPayload) return;
        if (
            currentPayload.actualMetaDataId === undefined ||
            currentPayload.baselineMetaDataId === undefined ||
            currentPayload.graphType === undefined ||
            currentPayload.isPartialCompletion === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    const { data, isFetching } = api.scurveGraph.instance;
    const sourceData = ui.state;
    const { themeStatus } = useThemeStatusStore();
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const pointsAnnotation = getPoints(data);
    const scurveSelectedData = filterDataBySelection(data, ui.state.graphLineOptions);
    const series = serializeData({ data: scurveSelectedData, isDarkMode: themeStatus });
    const options = serializeOptions({
        series,
        nowDate: data?.nowDate,
        themeStatus,
        isShowAnnotation: ui.state.showAnnotations,
        pointsAnnotation,
    });

    const noResults =
        !isFetching && data?.plannedGraphLine?.data?.length === 0 && data?.actualGraphLine?.data?.length === 0;

    const notApplicable =
        FILTER_LIST.includes(sourceData?.progressMeasurement) &&
        Boolean(sourceData?.resourceType?.length > 0 || sourceData?.resource);

    const noDataCondition = noResults || notApplicable;

    const chartHeight = WidgetViewModeUtils.isReportView(widgetViewMode)
        ? CHART_HEIGHT_IN_REPORT_VIEW
        : CHART_HEIGHT_IN_PAGE_VIEW;

    return {
        logic: {
            noDataCondition,
            options,
            series,
            notApplicable,
            chartHeight,
        },
    };
};
